// extracted by mini-css-extract-plugin
module.exports = {"container":"MiniWidgetContainer_container__1ek0g","topComponent":"MiniWidgetContainer_topComponent__rc4J7"};